<template>
  <div class="pa-10">
    <v-card class="mt-2">
      <v-row class="px-2">
        <v-col cols="12">
          <UserModulesDataTable />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import UserModulesDataTable from "../../components/Utils/UserModulesDataTable.vue";
export default {
  name: "UserModulesPage",
  components: { UserModulesDataTable },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),

  created() {
    // console.log("created");
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
      // location.reload();
    }
  },
  methods: {},
};
</script>

<style></style>
